import React, { useState } from "react";
import "../../assets/css/banner-mundial.css";
import GaleriaModalMundialComponent from "./galeria-modal-mundial.component";
import { buildCmsUrl } from "../../utils/imageHelper";

interface BannerMundialComponentProps {
  multicotizadorData?: any;
  worldCupData?: any;
}

const BannerMundialComponent: React.FC<BannerMundialComponentProps> = ({ multicotizadorData, worldCupData }) => {
  const [selectedGalery, setSelectedGalery] = useState<number | null>(null);

  const logoUrl = worldCupData?.intro_logo ? buildCmsUrl(worldCupData.intro_logo.url) : "";
  
  const galeriaData = {
    media: [
      worldCupData?.schedule_media1 ? buildCmsUrl(worldCupData.schedule_media1.url) : "",
      worldCupData?.schedule_media2 ? buildCmsUrl(worldCupData.schedule_media2.url) : "",
      worldCupData?.schedule_media3 ? buildCmsUrl(worldCupData.schedule_media3.url) : ""
    ],
    mediaType: ["image", "image", "image"]
  };

  return (
    <section className="mundial-hero">
      <div className="mundial-hero-bg"></div>
      
      <div className="mundial-hero-container">
        <div className="mundial-hero-logo">
          {logoUrl && <img src={logoUrl} alt="Hyundai Official Partner - FIFA World Cup 2026" />}
        </div>

        <div className="mundial-hero-content-row">
          <div className="mundial-hero-left" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <button 
              className="mundial-hero-btn"
              onClick={() => {
                const anchor = worldCupData?.schedule_button_url_anchor?.replace("#", "") || "cotizador";
                const element = document.getElementById(anchor);
                if (element) {
                  const offsetTop = element.offsetTop - 120;
                  window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth",
                  });
                }
              }}
            >
              {worldCupData?.schedule_button_text}
            </button>
          </div>

          <div className="mundial-hero-right">
            <div className="mundial-img-tall" onClick={() => setSelectedGalery(0)} style={{ cursor: "pointer" }}>
              {galeriaData.media[0] && <img src={galeriaData.media[0]} alt="Mundial Hyundai" />}
            </div>
            
            <div className="mundial-img-short" onClick={() => setSelectedGalery(1)} style={{ cursor: "pointer" }}>
              {galeriaData.media[1] && <img src={galeriaData.media[1]} alt="Mundial Hyundai" />}
            </div>
            
            <div className="mundial-img-short" onClick={() => setSelectedGalery(2)} style={{ cursor: "pointer" }}>
              {galeriaData.media[2] && <img src={galeriaData.media[2]} alt="Mundial Hyundai" />}
            </div>
          </div>
        </div>
      </div>
      
      <GaleriaModalMundialComponent 
        selectedGalery={selectedGalery}
        setSelectedGalery={setSelectedGalery}
        galeria={galeriaData}
      />
    </section>
  );
};

export default BannerMundialComponent;